import { languageHelper } from "../../../config/helperFunctions";
import React, { useRef, useState, useEffect } from "react";
import * as faceapi from "@vladmandic/face-api";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";

function FaceRegister() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const videoRef = useRef(null);

  const [cameraActive, setCameraActive] = useState(false);
  const [loading, setLoading] = useState(false);

  // Load models
  useEffect(() => {
    const loadModels = async () => {
      await faceapi.nets.tinyFaceDetector.loadFromUri("/models");
      await faceapi.nets.faceLandmark68Net.loadFromUri("/models");
      await faceapi.nets.faceRecognitionNet.loadFromUri("/models");
    };
    loadModels();
    return () => stopCamera();
  }, []);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      setCameraActive(true);
    } catch (error) {
      toast.error("Camera access denied. Please allow camera permission.", {
        position: "bottom-right",
        theme: "colored",
      });
    }
  };

  const stopCamera = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setCameraActive(false);
  };

  const captureFace = async () => {
  setLoading(true);

  try {
    const detection = await faceapi
      .detectSingleFace(videoRef.current, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceDescriptor();

    if (!detection) {
      toast.error("No face detected! Please try again.", {
        position: "bottom-right",
        theme: "colored",
      });
      setLoading(false);
      return;
    }

    const descriptor = JSON.stringify(Array.from(detection.descriptor));

    console.log("Submitting face descriptor...");

    const res = await axios.post(
      `${apiKey}/api/face-registration-by-user-account`,
      { face_image: descriptor },
      {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      }
    );

    if (res.data.success) {
      toast.success(res.data.message || "Face registered successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
      stopCamera();
      setTimeout(() => navigate(-1), 1000);
    } else {
      toast.error(res.data.message || "Face registration failed.", {
        position: "bottom-right",
        theme: "colored",
      });
    }
  } catch (err) {
    const status = err.response?.status;
    console.error("Face registration error:", err);

    if (status === 401) {
      toast.error("Session expired. Please login again.", {
        position: "bottom-right",
        theme: "colored",
      });
      stopCamera();
      localStorage.removeItem("rms-admin");
      navigate("/admin/login");
      return;
    }

    toast.error(err.response?.data?.message || "Something went wrong!", {
      position: "bottom-right",
      theme: "colored",
    });
  } finally {
    setLoading(false);
  }
};


  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-[#7B20C7] text-2xl">
            {languageHelper("Face Registration")}
          </h1>
        </div>

        <div className="flex flex-col items-center">
          <div className="w-[320px] h-[240px] bg-gray-200 rounded-md overflow-hidden shadow mb-4 relative">
            <video
              ref={videoRef}
              autoPlay
              muted
              width="320"
              height="240"
              className="rounded-md object-cover"
            ></video>
            {!cameraActive && (
              <div className="absolute inset-0 flex items-center justify-center text-gray-500">
                {languageHelper("Camera is off")}
              </div>
            )}
          </div>

          <div className="flex gap-3">
            {!cameraActive ? (
              <button
                onClick={startCamera}
                className="bg-[#7B20C7] text-white text-sm px-4 py-2 rounded shadow hover:shadow-lg transition-all duration-150"
              >
                {languageHelper("Start Camera")}
              </button>
            ) : (
              <button
                onClick={stopCamera}
                className="bg-red-600 text-white text-sm px-4 py-2 rounded shadow hover:shadow-lg transition-all duration-150"
              >
                {languageHelper("Stop Camera")}
              </button>
            )}

            <button
              onClick={captureFace}
              disabled={!cameraActive || loading}
              className={`text-sm px-4 py-2 rounded shadow transition-all duration-150 ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#7B20C7] text-white hover:shadow-lg"
              }`}
            >
              {loading ? "Processing..." : "Capture & Submit"}
            </button>

            <button
              onClick={() => {
                stopCamera();
                navigate(-1);
              }}
              className="bg-gray-500 text-white text-sm px-4 py-2 rounded shadow hover:shadow-lg transition-all duration-150"
            >
              {languageHelper("Back")}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default FaceRegister;
